import { getTenantDomain } from 'common/HelperFunctions';
import store from 'setup/redux/Store';
import { logSocketMessage as dispatchSocketLog } from 'setup/redux/Actions/Timetable/timetable';

// Types of socket events to log
export enum SocketEventType {
  TRANSITION = 'frontend_transition', // Connection events (connect, disconnect)
  TRACKING = 'frontend_tracking',     // Normal operation events (room join/leave, messages)
  FAILURE = 'frontend_failure'        // Error events
}

/**
 * Logs a socket event using Redux Saga
 * 
 * @param event - The socket event name (e.g., 'connect', 'disconnect', 'join-room')
 * @param data - The data or message associated with the event
 * @param type - The type of event (transition, tracking, failure)
 * @param count - Number of occurrences (default: 1)
 */
export const logSocketEvent = (
  event: string, 
  data: string, 
  type: SocketEventType, 
  count: number = 1
): void => {
  const tenant = getTenantDomain();
  const channel = tenant.split('.')[0];
  
  const payload = {
    tenant,
    channel,
    event,
    data,
    type,
    count
  };

  store.dispatch(dispatchSocketLog(payload, 
    () => {
      // Success callback - can be used for debugging if needed
      // console.log(`Socket event logged: ${event}`);
    }, 
    (error: any) => {
      // Log to console only on errors
      console.error('Error logging socket event:', error);
    }
  ));
};

// Helper methods for common event types
export const logSocketConnection = (data: string): void => {
  logSocketEvent('connect', data, SocketEventType.TRANSITION);
};

export const logSocketDisconnection = (data: string): void => {
  logSocketEvent('disconnect', data, SocketEventType.TRANSITION);
};

export const logSocketRoomJoin = (roomName: string): void => {
  logSocketEvent('join-room', `Joined room: ${roomName}`, SocketEventType.TRACKING);
};

export const logSocketRoomLeave = (roomName: string): void => {
  logSocketEvent('leave-room', `Left room: ${roomName}`, SocketEventType.TRACKING);
};

export const logSocketMessageEvent = (eventName: string, data: any): void => {
  logSocketEvent(eventName, `Message sent: ${JSON.stringify(data)}`, SocketEventType.TRACKING);
};

export const logSocketError = (event: string, errorMessage: string): void => {
  logSocketEvent(event, errorMessage, SocketEventType.FAILURE);
}; 